<template lang="pug">
header.dawn-meta-nav
  .container-fluid
    ul.meta-nav-menu
      li.meta-nav-item
        a(href="#")
          i.fal.fa-question-circle
      li.meta-nav-item
        a(href="#")
          i.fas.fa-bell
        span.notification(v-show='events.length') {{events.length}}
      li.meta-nav-item.meta-nav-user.meta-nav-dropdown
        a(v-on:click='showDropdown = !showDropdown') {{this.$user.email || 'Welcome !'}}
          i.fa.fa-caret-down
        .meta-nav-dropdown(v-if="showDropdown")
          ul.meta-nav-dropdown-menu
            li.meta-nav-dropdown-title
              span {{this.$user.email}}
              span.close-icon(v-on:click='showDropdown = !showDropdown')
                i.fas.fa-times
            li.meta-nav-dropdown-item
              a(href="#") {{ $t('My Profile') }}
            li.meta-nav-dropdown-item
              a(href="#") {{ $t('My Settings') }}
            li.meta-nav-dropdown-item
              a(href="#" @click='logout()') {{ $t('Logout') }}
</template>

<script>

import '@/core/notifications'
import events from '@/core/events/events'

export default {
  name: 'ed-meta-nav',

  data () {
    return {
      showDropdown: false,
      events: events.queue
    }
  },

  methods: {
    logout() {
      this.$user.logout()
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-meta-nav {
  position: relative;
  z-index: 9999;
  display: block;
  width: 100%;
  padding: .3rem $side-padding;
  text-align: right;
  font-size: $font-size-small;
  line-height: $font-size-small;
  background: $primary-05;
  background: t(primary-05, $primary-05);
}

ul.meta-nav-menu {
  display: inline-block;
  list-style: none;
  padding: 0;
  position: relative;
  text-align: left;
  margin-bottom: 0;

  li.meta-nav-item {
    position: relative;
    display: inline-block;
    margin: 0rem .5rem;

    &.meta-nav-dropdown {
      position: static;
    }

    a {
      color: $canvas;
      opacity: 0.3;
      transition: opacity .5s ease-out;
      &:hover {
        opacity: 1;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }

  li.meta-nav-user {
    margin-left: 2rem;
  }

  div.meta-nav-dropdown {
    position: absolute;
    top: -.3rem;
    left: 1rem;
    background: $canvas;
    box-shadow: $box-shadow;
    padding: 0.3rem 1rem 1rem 1rem;
    width: 100%;
    z-index: 9999;

    ul.meta-nav-dropdown-menu {
      list-style: none;
      padding: 0;

      li.meta-nav-dropdown-title {
        font-weight: $font-weight-bold;
        margin-bottom: .3rem;
        color: $primary-05;

        span.close-icon {
          color: $primary-05;
          position: absolute;
          right: 1rem;
          top: .3rem;
          &:hover {
            cursor: pointer;
          }
        }
      }

      li.meta-nav-dropdown-item {
        border-radius: $border-radius;
        padding: .3rem 0rem;
        a {
          padding: .5rem;
          color: $primary-05;
          opacity: 1;
          font-size: $font-size-xsmall;
          line-height: 1rem;
        }

        &:hover {
          background: $background-light;
          transition: all .5s ease-out;
        }

      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// index.vue?621ef3e6